import EventService from "./event";

export default class StoreService {
    
    static setSettings(key, data) {
        store.settings[key] = data;
    }

    static getSettings(key) {
        return store.settings[key];
    }

    static setUser(user) {
        store.user = user;
        EventService.emit('user');
    }

    static getUser() {
        return store.user;
    }

};

const store = {
    user: {},
    setting: {},
};
